module.exports = __webpack_public_path__ + "images/dingtalk/plane-58feb75c943cf48bbfac0130efda3718.png";